import TriggerSettings from "./Popups/TriggerSettings.svelte";
import StepSettings from "./Popups/StepSettings.svelte";
import GoalSettings from "./Popups/GoalSettings.svelte";
import StickyNotes from "./Popups/StickyNotes.svelte";
import {External, M} from "../external";
import {getUTMSalesTotals} from "../Store/static";

export function validate(step) {
  return {
    flow: function () {
      return true;
    },
    analytics: function () {
      return true;
    }
  }[step]();
}

export function getEmailBuilderFeatures(automation) {
  let features = {};
  if (automation.flow && automation.flow.start && automation.flow.start.triggers) {
    if (automation.flow.start.triggers.filter(trigger => trigger.type === "CART_ABANDON").length > 0) {
      features.defaultLink = '{checkout_url}';
      features.hasCartWidget = true;
    }
  }
  return features;
}

export function getExtraAutomationGoals(automation) {
  let goals = [];
  if (automation && automation.flow && automation.flow.start && automation.flow.start.triggers) {
    if (automation.flow.start.triggers.filter(trigger => trigger.type === "CART_ABANDON").length > 0) {
      // abandoned cart automations have the "ABANDONED_CART_RECOVER" goal
      goals.push("ABANDONED_CART_RECOVER");
    }
  }
  return goals;
}

export function clickForTriggerSettings(type, data, onSave) {
  if (type === "CART_ABANDON") {
    let data = {
      type: type,
      settings: []
    };
    onSave(data);
    return;
  }

  let component;
  let changed = false;
  External.Tools.showWindow({
    title: M.TRIGGER_SETTINGS,
    icon: External.Popup.ICON_EDIT,
    width: 500,
    customClass: "add-member-dialog",
    isModal: false,
    withDarkBackground: true,
    forceAtRight: External.showBuilderPopupsOnFullHeight,
    markup: '<div class="popup-widget-wrapper bind-component"></div>',
    action: {
      onShow: function (popup, ui) {
        component = new TriggerSettings({
          target: ui.find(".bind-component")[0],
          props: {
            data: {
              id: !data ? null : data.id,
              name: !data || !data.name ? null : data.name,
              type: !data || !data.type ? type : data.type,
              settings: !data ? null : data.settings
            },
            onChange: () => {
              changed = true;
            }
          }
        });
      },
      onBeforeHide: function (popup, ui) {
        if (component && changed && !component.isValid()) {
          External.Tools.showError(M.SETTINGS_ARE_INCORRECT);
          return false;
        }
      },
      onHide: function () {
        if (component) {
          if (changed && onSave) {
            onSave(component.get());
          }

          component.$destroy();
          component = null;
        }
      }
    }
  });
}

export function clickForGoalSettings(type, data, onSave) {
  if (type === "ABANDONED_CART_RECOVER") {
    let data = {
      type: type,
      settings: []
    };
    onSave(data);
    return;
  }

  let component;
  let changed = false;
  External.Tools.showWindow({
    title: M.GOAL_SETTINGS,
    icon: External.Popup.ICON_EDIT,
    width: 500,
    customClass: "add-member-dialog",
    isModal: false,
    withDarkBackground: true,
    forceAtRight: External.showBuilderPopupsOnFullHeight,
    markup: '<div class="popup-widget-wrapper bind-component"></div>',
    action: {
      onShow: function (popup, context) {
        component = new GoalSettings({
          target: context.find(".bind-component")[0],
          props: {
            data: {
              id: !data ? null : data.id,
              name: !data || !data.name ? null : data.name,
              type: !data || !data.type ? type : data.type,
              settings: !data ? null : data.settings
            },
            onChange: () => {
              changed = true;
            }
          }
        });
      },
      onBeforeHide: function (popup, ui) {
        if (component && changed && !component.isValid()) {
          External.Tools.showError(M.SETTINGS_ARE_INCORRECT);
          return false;
        }
      },
      onHide: function () {
        if (component) {
          if (changed && onSave) {
            onSave(component.get());
          }

          component.$destroy();
          component = null;
        }
      }
    }
  });
}

export function clickForStepSettings(
  type,
  data,
  add,
  update,
  parentPopup,
  order,
  automation,
  stepId,
  automationSave
) {
  let component;
  let changed = false;
  External.Tools.showWindow({
    title: M.STEP_SETTINGS,
    icon: External.Popup.ICON_EDIT,
    width: 500,
    customClass: "add-member-dialog",
    isModal: false,
    withDarkBackground: true,
    forceAtRight: External.showBuilderPopupsOnFullHeight,
    markup: '<div class="popup-widget-wrapper bind-component"></div>',
    action: {
      onShow: function (popup, context) {
        component = new StepSettings({
          target: context.find(".bind-component")[0],
          props: {
            data:
              data ?
                data :
                {
                  type: type
                },
            automation: automation,
            stepId: stepId,
            automationSave: automationSave,
            stepAdd: add,
            stepUpdate: update,
            order: order,
            onChange: () => {
              changed = true;
            }
          }
        });
      },
      onBeforeHide: function () {
        if (component && changed && !component.isValid()) {
          let error = component.getError() || M.SETTINGS_ARE_INCORRECT;
          External.Tools.showError(error);
          return false;
        }
      },
      onHide: function () {
        if (component) {
          if (changed && (add || update)) {
            let step = component.get();
            if (!step.order) step.order = order;
            if (add) add(step);
            if (update) update(step);
            if (parentPopup) parentPopup.close();
            External.CPanel.setChanged(true);
          }
          component.$destroy();
          component = null;
        }
      }
    }
  });
}

export function editStepNotes(notes, onChange) {
  let component;
  External.Tools.showWindow({
    title: M.STICKY_NOTES,
    icon: External.Popup.ICON_EDIT,
    width: 500,
    customClass: "add-member-dialog",
    isModal: false,
    withDarkBackground: true,
    forceAtRight: External.showBuilderPopupsOnFullHeight,
    markup: '<div class="popup-widget-wrapper bind-component"></div>',
    action: {
      onShow: function (popup, context) {
        component = new StickyNotes({
          target: context.find(".bind-component")[0],
          props: {
            data: notes || [],
            onChange: () => {
              onChange(component.get());
            }
          }
        });
      },
      onHide: function () {
        if (component) {
          component.$destroy();
          component = null;
        }
      }
    }
  });
}

export function makeId(length) {
  let result = "";
  let characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let charactersLength = characters.length;
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

export function sendTestEmail(content, defaultEmail) {
  //External.Tools.promptForInput(M.SEND_TEST_EMAIL, M.ENTER_TEST_EMAIL, defaultEmail || "", function (email) {
    External.Tools.makeWebsiteRequest({
      action: "sendAutomationTestEmail",
      method: 'post',
      data: {
        content: JSON.stringify(content),
 //       toRecipient: email
      },
      onOk: function () {
        External.Tools.showAutohideMessage(5, External.userEmail + ' - ' + M.TEST_MESSAGE_SENT);
      }
//    });
  });
}

export async function getAutomationSalesTotals(automation, ...salesUtm) {
  if(!salesUtm) {
    salesUtm = getAutomationSalesUTMs();
  }
  const fromDate = new Date(automation.modified.epochSecond * 1000);
  return await getUTMSalesTotals(fromDate, new Date(), ...salesUtm);
}

export function getAutomationSalesUTMs(automation) {
  const steps = getEmailAndMessageSteps(automation.flow.steps);
  const stepsUtms = [];

  for (const step of steps) {
    const stepUtm = getStepSalesUTM(step);

    if (stepUtm) {
      if (!stepsUtms.includes(stepUtm)) {   //some steps may have identical UTM params, so dont count them twice
        stepsUtms[stepsUtms.length] = stepUtm;
      }
    }
  }

  return stepsUtms;
}

export function getStepSalesUTM(step) {
  let salesUtm;

  if (step.type === "SEND_EMAIL" || step.type === "SEND_SMS" || step.type === "SEND_WHATSAPP") {
    const salesUtmSetting = step.settings.find(setting => setting.key === "salesUtm");

    if (salesUtmSetting) {
      salesUtm = JSON.parse(salesUtmSetting.value);
    }
  }

  return salesUtm;
}

export function getEmailAndMessageSteps(steps) {
  let emailMsgSteps = [];

  steps.forEach((step) => {
    if (step.type === "SEND_EMAIL" || step.type === "SEND_SMS" || step.type === "SEND_WHATSAPP" || step.type === "SEND_VOICE") {
      emailMsgSteps.push(step);
    }

    if (step.subflowA && step.subflowA.length > 0) {
      emailMsgSteps = [...emailMsgSteps, ...getEmailAndMessageSteps(step.subflowA)];
    }

    if (step.subflowB && step.subflowB.length > 0) {
      emailMsgSteps = [...emailMsgSteps, ...getEmailAndMessageSteps(step.subflowB)];
    }
  });

  return emailMsgSteps;
}

export function viewFullAnalytics(automationId) {
  External.CPanel.goToUrl('/me/crm/marketing/automation?tab=analytics&id=' + automationId, true);
}
